import TheGallery from "./TheGallery";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import EventTabNav from "../components/EventTabNav";

const AdminPanel = ({ event, setPageName, setSelectedE }) => {
  const navigate = useNavigate();

  useEffect(() => {
    setPageName("Edit gallery" + (event ? ` - ${event.name}` : ""));
  }, [event]);

  const gotoEvents = () => {
    setSelectedE(event.id_name);
    navigate("/admin/events");
  };

  if (!event) return null;

  return (
    <>
      <EventTabNav onBack={gotoEvents} />
      <TheGallery key={event.event_id} event_id={event.event_id} event={event} admin={true} />
    </>
  );
};

export default AdminPanel;
